import React from 'react';
import '../CSS/Profile/KennyDaughertyProfile.css';

const KennyDaughertyProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/kenny-daugherty-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Kenny Daugherty"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Kenny Daugherty</h1>
        <div className="profile-title-container">
          <p className="profile-title">President</p>
          <a href="https://www.linkedin.com/in/kenny-daugherty-55941b154/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            Kenny Daugherty joined Myers McRae in 2008 as Executive Vice President and Chief Operating Officer and was named President in 2016. His specialty is identifying and attracting highly qualified, undeclared candidates for searches.
          </p>
          <p>
            He has 28 years of managerial experience in public and independent institutions, with responsibilities in interdepartmental cooperation and personnel management. He is known for his ability to assess candidates, leading to his placement on numerous search committees.
          </p>
          <p>
            His higher education administration career began at the University of Alabama. For 11 years, he served in facilities, planning, and services for Housing and Residential Life. He designed and managed a seven-year facility planning process for renovations, projects, new construction, and a building audit system. He also served as a University Total Quality Management Facilitator, leading TQM teams, and as a judicial officer.
          </p>
          <p>
            In 1996, he joined Mercer University as Assistant Vice President for Development, progressing to Vice President for Advancement Administration by 2003. He provided strategic management and planning for 10 operational areas: development, capital campaign, alumni services, public relations, government relations, records and research, admissions, and financial aid. He was instrumental in recruiting volunteer leadership and major contributors, contributing to a 35% growth in donors.
          </p>
          <p>
            He assisted with restructuring the Admissions Office, developing and implementing recruiting and scholarship strategies. This led to an increase of over 50 freshman students in the first year, making it the largest freshman class in Mercer history, and a 67-point rise in SAT averages.
          </p>
          <p>
            He earned his bachelor's and master's degrees from Mercer University. During graduate school, he served as the Assistant Men's Basketball Coach, recruiting high school and junior college players in the Southeast and Midwest, and hiring and supervising managerial staff.
          </p>
        </div>
      </div>
    </div>
  );
};

export default KennyDaughertyProfile;

